// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Configuración de Firebase (pon la tuya aquí)
const firebaseConfig = {
  apiKey: "AIzaSyB74ubuYXcp46t-s5s041AC4fCWd0mJls8",
  authDomain: "doinaro28.firebaseapp.com",
  projectId: "doinaro28",
  storageBucket: "doinaro28.firebasestorage.app",
  messagingSenderId: "1063485509229",
  appId: "1:1063485509229:web:2ddbd318c67551a0f8f964",
  measurementId: "G-S8ZTN0PX4Y"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Inicializar Firestore
const db = getFirestore(app);

// Exportar ambos
export { app, db };